
  
  const envConfig = {
    apiBase: '',
    invalidCategory: ['app', 'form', 'none', 'web']
  };
  
  export default envConfig;
  